import React, { useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Context } from '../../../context/global-data-provider';
import CategorySlider from '../../components/category/category-slider';
import ListRates from '../ListRates/ListRates';
import OptionsAndMenu from './components/OptionsAndMenu/OptionsAndMenu';
import './header-style.css';

function Header() {
  const { options } = useContext(Context);

  const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 736px)' });
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 735px)' });

  return (
    <React.Fragment>
      <header className={(isDesktopOrLaptop ? 'v-header' : 'h-header') + ' f-row'}>
        <section className="bio-section f-shrink-1 f-grow-sm-1 f-basis-sm-0 f-grow-lg-2 f-basis-lg-30p justify-content-center">
          <div className="bio-wrapper align-items-center f-shrink-1 f-row">
            <h1 className="title d-block o-hidden to-ellipsis w-space-nowrap">{options.title}</h1>
          </div>

          {isDesktopOrLaptop && (
            <ul className="d-flex f-row">
              <li className="pc-info">
                <span className="color-inherit-all">
                  <span className="pc-n">{options.number_posts} </span>پست
                </span>
              </li>
              <li className="pc-info">
                <span className="color-inherit-all">
                  <span className="pc-n">{options.number_comments} </span>نظر
                </span>
              </li>
            </ul>
          )}

          {isDesktopOrLaptop && <OptionsAndMenu style={{ marginTop: '12px' }} />}
        </section>

        <div className={`logo f-shrink-0 justify-content-sm-center f-basis-lg-0 f-grow-lg-1`}>
          <div className="d-block align-items-center align-self-center f-none justify-content-center c-p">
            <span className="logo-wrapper d-block p-relative o-hidden bs-border-box f-00auto">
              <img alt={options.title} className="logo-img" src={options.logo} />
            </span>
          </div>
        </div>
      </header>

      <div className={`sm-bio d-flex flex-column gap-12 ${isDesktopOrLaptop ? 'px-0' : ''}`}>
        <div className={`d-block to-ellipsis w-space-pre-line ${isDesktopOrLaptop ? 'px-0' : ''}`}>
          {options.about_us &&
            options.about_us.split('\n').map((str, i) => {
              return (
                <React.Fragment key={i}>
                  {str.trim().length > 0 && (
                    <React.Fragment>
                      {str.trim()}
                      <br />
                    </React.Fragment>
                  )}
                  <br />
                </React.Fragment>
              );
            })}{' '}
        </div>

        {isTabletOrMobile && <OptionsAndMenu />}

        <ListRates ws={false} />
      </div>

      <CategorySlider path={'/category'} />

      {isTabletOrMobile && (
        <ul className="sm-pc-info d-flex f-row justify-content-around">
          <li className="item">
            <span className="content f-row">
              <span className="d-inline-flex text-center ml-6p">{options.number_posts} </span>پست
            </span>
          </li>
          <li className="item">
            <span className="content f-row">
              <span className="d-inline-flex text-center ml-6p">{options.number_comments} </span>نظر
            </span>
          </li>
        </ul>
      )}
    </React.Fragment>
  );
}

export default Header;
